// Pure helpers for the marital-status issue's decide flow (Grant
// 2026-07-13 — marital status now routes to the household's advisor, not
// the back office). Its recommended "verify" SETS the marital status on
// the primary contact (picking it IS the action), and its "keep-current"
// is the honest terminal escape ("We don't know their marital status")
// which writes a durable unknown marker (migration 0202) so nobody is
// asked again.
//
// Same pattern + conventions as client-since-issue.ts / pm-entity-issue.ts.
// Root-safe (imports nothing) so it's unit-tested from tests/web/.

export interface MaritalIssueLike {
  detectorSlug: string;
}

export function isMaritalIssue(issue: MaritalIssueLike): boolean {
  return issue.detectorSlug === "judgment-marital-status-missing";
}

// marital_status is a free-text column; these are the one-click values
// (mirroring the Contact form + DataNeededPage's suggested set).
export const MARITAL_OPTIONS = [
  "Married",
  "Single",
  "Divorced",
  "Widowed",
  "Partnered",
  "Separated",
] as const;

export function isValidMaritalInput(s: string): boolean {
  return s.trim().length > 0 && s.trim().length <= 60;
}

export function maritalConsequence(value: string): string {
  if (value && isValidMaritalInput(value)) {
    return `Sets this client's marital status to “${value.trim()}” and resolves this issue — it shapes household structure and beneficiary/planning context. Audited; reversible for 60 seconds.`;
  }
  return "Pick the marital status — setting it is the whole action here. Genuinely unknown? Use “We don't know their marital status” below.";
}

export const MARITAL_UNKNOWN_LABEL = "We don't know their marital status";

export function maritalUnknownConsequence(): string {
  return "Records that nobody knows this client's marital status — the item resolves for the whole team and it won't be asked again. If it's ever learned, setting it clears this answer. Reversible for 60 seconds (undo clears the answer and reopens the item).";
}
